module.exports = {
  "tz": "Asia/Tokyo",
  pattern: {
    email: /^[A-Za-z0-9]{1}[A-Za-z0-9_.\+\-]*@{1}[A-Za-z0-9_.-]+.[A-Za-z0-9]+$/,
  },
  Ubitus: {
    js: process.env.UBITUS_JS,
    channel: process.env.UBITUS_CHANNEL,
    server: process.env.UBITUS_SERVER,
    providerId: process.env.UBITUS_PROVIDERID,
  },
  EnvName: process.env.APP_ENV_NAME,

  amazonPayAmounts: [
    1000,
    2000,
    3000,
    5000,
    10000,
    30000,
  ],
  ganbAmounts: [
    1000,
    2000,
    3000,
    5000,
    10000,
    30000,
  ],
  cvsCommisionThresholdAmount: 5000,
  cvsCommisionAmount: 180,
  cvsAmounts: [
    1000,
    2000,
    3000,
  ],
  cvsCommissionFreeAmounts: [
    5000,
    10000,
    30000,
    100000,
  ],
  DEBUG: process.env.DEBUG == 'yes',
  GMOPG: {
    shopId: (process.env.GMOPG_SHOPID).toString(),
    gateway: process.env.GMOPG_GOOGLEPAY_GATEWAY || 'gmopg',
    googlePayMerchantId: process.env.GMOPG_GOOGLEPAY_MERCHANTID || 'BCR2DN4TQP73T6JG',
    googlePayEnvironment: process.env.GMOPG_GOOGLEPAY_ENVIRONMENT || 'PRODUCTION',
  },
  RAKUTEN: {
    serviceId: process.env.RAKUTEN_SERVICEID,
  },
  cvs: [
    {
      code: '10001', // LAWSON
      name: 'ローソン',
      img: 'https://imagedelivery.net/qa6Tzad6bwKOH_OWv1jzvA/70c4a11b-30a6-48a1-c824-11945ddc8f00/public',
    },
    {
      code: '10002', // FamilyMart
      name: 'ファミリーマート',
      img: 'https://imagedelivery.net/qa6Tzad6bwKOH_OWv1jzvA/e0d58a13-c96d-4130-f083-edf6e1f24300/public',
    },
    {
      code: '10005', // MiniStop
      name: 'ミニストップ',
      img: 'https://imagedelivery.net/qa6Tzad6bwKOH_OWv1jzvA/75ccadbc-8d30-46f7-af50-acc2d3b52400/public',
    },
    {
      code: '10008', // Seicomart
      name: 'セイコーマート',
      img: 'https://imagedelivery.net/qa6Tzad6bwKOH_OWv1jzvA/c53d599c-8753-48ff-366a-81eb5e2bde00/public',
    },
  ],
};

